var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"emptyVideoPage"},[_c('div',{staticClass:"icon add-video-guidance",on:{"click":_vm.filePicker}},[_c('iconfont',{attrs:{"name":"#icon10-10tianjiashipin","font-size":"48px"}})],1),_c('span',{staticClass:"tipTitle"},[_vm._v("添加视频")]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }